export default "__VITE_ASSET__DadpkQ0F__"